// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__10LSB","label":"styles_label__1dQCf","info":"styles_info__11I0k","picker":"styles_picker__2A2nl"};